export const url = window.location.origin;
(function(){
    var api = {url:url}//https://xudaxianer.cn
    window.myurl=api
})();